import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui';
const modulesData = [{
  num: '01',
  title: 'Obiectivele NLP. Dă direcție clară minții tale.',
  image: 'https://cdn.magicpatterns.com/uploads/ggNbtKhJwUmvFZpAFhz6rZ/Modul_1.png',
  bullets: ['Înveți să formulezi obiective clare, nu vagi, astfel încât mintea ta să știe exact unde merge.', 'Descoperi ce vrei cu adevărat, nu doar ce vrei să eviți, și cum să creezi motivație internă reală.', 'Ieși cu un plan de acțiune pe care îl poți urma chiar a doua zi, fără să mai amâni.']
}, {
  num: '02',
  title: 'Rapport NLP. Conectează-te cu oamenii la un nivel profund.',
  image: 'https://cdn.magicpatterns.com/uploads/eoDusx3pLWQhyuMCE4zxHs/Modul_2.png',
  bullets: ['Înveți cum se creează conexiunea autentică: sincronizare nonverbală, ritm, energie, limbaj comun.', 'Descoperi cum gândesc ceilalți oameni după cum se mișcă ochii și forma corpului lor.', 'Înveți să conduci o conversație elegant, fără presiune, după ce ai obținut încrederea celeilalte persoane.']
}, {
  num: '03',
  title: 'Submodalitățile NLP. Editează filmul din capul tău.',
  image: 'https://cdn.magicpatterns.com/uploads/f89dgT1A2HfrgUuFXATnEL/Modul_3.png',
  bullets: ['Descoperi că o amintire, o frică sau o motivație au o structură internă clară care poate fi modificată.', 'Înveți cum să schimbi impactul emoțional al unei experiențe fără să ștergi ce s-a întâmplat.', 'Creezi reprezentări interne care te susțin în loc să te blocheze.']
}, {
  num: '04',
  title: 'Ancorele NLP. Accesează starea potrivită exact când ai nevoie.',
  image: 'https://cdn.magicpatterns.com/uploads/pQsKTbuXSL3dbK2k8hZN7Z/Modul_4.png',
  bullets: ['Înveți ce este o ancoră, adică o legătură dintre o stare interioară și un semnal, și cum se creează una bună.', 'Instalezi stări de calm, curaj, concentrare sau încredere, accesibile rapid în orice moment.', 'Înveți să desfaci ancorele negative pe care le-ai creat în trecut fără să vrei.']
}, {
  num: '05',
  title: 'Linia Timpului NLP. Eliberează trecutul, construiește viitorul.',
  image: 'https://cdn.magicpatterns.com/uploads/xg4wrYXJvG8fVm2uFRDNzP/Modul_5.png',
  bullets: ['Înveți cum mintea ta stochează amintirile și cum trecutul poate consuma energie în prezent.', 'Schimbi relația emoțională cu evenimente care încă te afectează, fără să negi că s-au întâmplat.', 'Construiești o orientare mai clară și mai motivantă spre viitor, bazată pe resurse reale.']
}, {
  num: '06',
  title: 'Limbajul Meta și Milton. Claritate când ai nevoie de adevăr, finețe când ai nevoie de influență.',
  image: 'https://cdn.magicpatterns.com/uploads/5jec6argSehX9Lo8Xnc22B/Modul_6.png',
  bullets: ['Prin Limbajul Meta înveți să identifici formulările vagi și confuze și să pui întrebări care clarifică adevărul din spatele cuvintelor.', 'Prin Limbajul Milton înveți să construiești sugestii non-invazive, metafore și povești cu impact, care deschid mintea omului fără confruntare.', 'Ieși cu o comunicare mai matură, mai convingătoare și mai elegantă în orice tip de conversație.']
}, {
  num: '07',
  title: 'Integrare, recapitulare și certificare NLP Practitioner.',
  image: 'https://cdn.magicpatterns.com/uploads/hRVmUnUdNVcTAd3oJmktZh/Modul_7.png',
  bullets: ['Legi între ele toate tehnicile din program și exersezi aplicat, ca să pleci cu instrumente vii, nu cu noțiuni frumoase.', 'Primești feedback personalizat și fixezi pașii de aplicare în viața ta reală.', 'Susții procesul de certificare și primești diplomele naționale și internaționale.']
}];
export const Modules = () => {
  return <section id="module" className="py-24 bg-navy-dark relative overflow-hidden border-y border-gold/10" data-id="element-263">
      <div className="container mx-auto px-6 relative z-10" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-4xl mx-auto mb-20" data-id="element-265">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-266">
            Ce facem concret în cele 7 module ale programului
          </h2>
          <div className="w-24 h-px bg-gold mx-auto" data-id="element-267" />
          {/* Photo below title - mobile only */}
          <div className="lg:hidden mt-10 relative aspect-[4/3] max-w-md mx-auto overflow-hidden border border-gold/20" data-id="element-268">
            <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80" alt="NLP Training" className="w-full h-full object-cover opacity-80" data-id="element-269" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/80 via-transparent to-transparent" data-id="element-270" />
          </div>
        </motion.div>
        <div className="space-y-20 max-w-6xl mx-auto" data-id="element-271">
          {modulesData.map((mod, idx) => {
          const isEven = idx % 2 === 0;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${!isEven ? 'lg:direction-rtl' : ''}`} data-id="element-272">
                {/* Image */}
                <div className={`relative ${!isEven ? 'lg:order-2' : ''}`} data-id="element-273">
                  <div className="relative aspect-[4/3] overflow-hidden border border-gold/20" data-id="element-274">
                    <img src={mod.image} alt={mod.title} className="w-full h-full object-cover opacity-80" data-id="element-275" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/80 via-transparent to-transparent" data-id="element-276" />
                    {/* Module number overlay */}
                    <div className="absolute bottom-4 left-4 flex items-center gap-3" data-id="element-277">
                      <span className="font-serif text-6xl font-bold text-gold/30 leading-none" data-id="element-278">
                        {mod.num}
                      </span>
                    </div>
                  </div>
                  {/* Decorative corner */}
                  <div className={`absolute -bottom-3 ${isEven ? '-left-3' : '-right-3'} w-20 h-20 border-b border-gold/40 ${isEven ? 'border-l' : 'border-r'}`} data-id="element-279" />
                </div>
                {/* Text */}
                <div className={`${!isEven ? 'lg:order-1' : ''}`} data-id="element-280">
                  <div className="flex items-center gap-4 mb-4" data-id="element-281">
                    <span className="font-display text-gold text-base font-semibold tracking-widest uppercase" data-id="element-282">
                      Modulul {mod.num}
                    </span>
                    <div className="flex-1 h-px bg-gold/20" data-id="element-283" />
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-6 leading-tight" data-id="element-284">
                    {mod.title}
                  </h3>
                  <ul className="space-y-4" data-id="element-285">
                    {mod.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-4" data-id="element-286">
                        <CheckCircle2 className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-287" />
                        <span className="font-sans text-white text-xl leading-relaxed" data-id="element-288">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>;
        })}
        </div>
        <div className="text-center mt-16" data-id="element-289">
          <Button data-id="element-290">Scrie-mi pe WhatsApp pentru detalii!</Button>
        </div>
      </div>
    </section>;
};